import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { BoxIcon } from '#atoms';
import { Modal } from '#molecules';

import { PortfolioModal } from '#molecules/PortfolioModal';
import { InputBox, InputIconBox } from 'src/components/pages/Portfolio/styles';

const PortfolioUserInfo = ({
  sexRegisterName,
  ageRegisterName
}: {
  sexRegisterName: string;
  ageRegisterName: string;
}) => {
  const methods = useFormContext();
  const [isModal, setIsModal] = useState(false);

  const onClickHandlerModal = () => {
    setIsModal(true);
  };

  const inputValue =
    methods.getValues(ageRegisterName) && methods.getValues(sexRegisterName)
      ? `${
          PARSE_GENER[methods.getValues(sexRegisterName)]
        } · ${methods.getValues(ageRegisterName)}세`
      : '';

  return (
    <>
      <InputIconBox onClick={onClickHandlerModal}>
        <InputBox
          type="text"
          placeholder="회원 정보를 입력해 주세요"
          value={inputValue}
          disabled
        />
        <BoxIcon type="next-arrow" onlyIcon size={15} />
      </InputIconBox>
      {isModal && (
        <Modal onClose={() => setIsModal(false)}>
          <PortfolioModal onClose={() => setIsModal(false)} />
        </Modal>
      )}
    </>
  );
};

export default PortfolioUserInfo;

const PARSE_GENER: Record<string, string> = {
  male: '남성',
  female: '여성'
};
